import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import { useUnreadChangesCount } from "../hooks/useUnreadChangesCount";

const Header: React.FC = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState(false);
  const { unreadCount } = useUnreadChangesCount();

  const mainNavLinks = [
    { path: "/", label: "Tableau de Bord" },
    { path: "/codings", label: "Codages" },
    { path: "/supervisions", label: "Supervisions" },
    { path: "/changes", label: "Modifications" },
    { path: "/contracts", label: "Contrats" },
    { path: "/reports", label: "Rapports" },
  ];

  const settingsMenuItems = [
    { path: "/coders", label: "Codeurs" },
    { path: "/supervisors", label: "Superviseurs" },
    { path: "/games", label: "Matchs" },
    { path: "/enterprises", label: "Entreprises" },
    { path: "/sync-logs", label: "Journaux de Sync" },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Check if any settings menu item is active
  const isSettingsActive = settingsMenuItems.some(
    (item) => location.pathname === item.path,
  );

  return (
    <header>
      <nav className="main-nav">
        <div className="nav-logo">
          <Link to="/" className="logo-link">
            <img src="/AIA_logo.png" alt="AIA Sports" className="logo-image" />
          </Link>
        </div>

        <div className="desktop-nav">
          {mainNavLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-btn ${
                location.pathname === link.path ? "active" : ""
              }`}
            >
              {link.label}
              {link.path === "/changes" && unreadCount > 0 && (
                <span className="notification-badge">{unreadCount}</span>
              )}
            </Link>
          ))}

          <div
            className="settings-dropdown"
            onMouseEnter={() => setIsSettingsDropdownOpen(true)}
            onMouseLeave={() => setIsSettingsDropdownOpen(false)}
          >
            <button
              className={`settings-btn ${isSettingsActive ? "active" : ""}`}
            >
              Paramètres
              <span className="dropdown-arrow">▼</span>
            </button>
            {isSettingsDropdownOpen && (
              <div className="settings-dropdown-menu">
                {settingsMenuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`settings-dropdown-item ${
                      location.pathname === item.path ? "active" : ""
                    }`}
                    onClick={() => setIsSettingsDropdownOpen(false)}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>

        <button
          className={`hamburger-menu ${isMobileMenuOpen ? "open" : ""}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="hamburger-icon"></span>
        </button>
      </nav>

      <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
        {mainNavLinks.map((link) => (
          <Link
            key={link.path}
            to={link.path}
            className={`mobile-nav-link ${
              location.pathname === link.path ? "active" : ""
            }`}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {link.label}
            {link.path === "/changes" && unreadCount > 0 && (
              <span className="notification-badge">{unreadCount}</span>
            )}
          </Link>
        ))}

        <div className="mobile-settings-section">
          <div className="mobile-settings-header">Paramètres</div>
          {settingsMenuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link mobile-settings-item ${
                location.pathname === item.path ? "active" : ""
              }`}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
